// ---------------------------------------------------------------------------
// PRODUCT IDENTITY — one of the first files to edit for a new project.
// ---------------------------------------------------------------------------
//
// Everything the app renders as "who this product is" comes from here, so
// rebranding is one edit rather than a hunt through components.
//
// NOT here, deliberately:
//   - API URLs and environment settings          -> .env / config/model.ts
//   - the product's screens and navigation       -> config/domain-config.tsx
//   - long-form marketing copy (about, contact,
//     privacy, terms)                            -> screens/public/*
//     Those are per-product prose, not settings; replace the files.
//
// ALSO CHANGE THIS OUTSIDE TS when starting a new project — Vite copies
// public/ verbatim, so it cannot be templated from here:
//   - public/manifest.json          name + short_name + description
// (index.html's <title> IS wired to this file, via the product-name-html
//  plugin in vite.config.ts — leave its %PRODUCT_NAME% placeholder alone.)

export interface PlatformConfig {
  /** Display name shown in the header, on the login screen and in page titles. */
  platform_name: string;
  /** Legal entity behind the product, for policy pages and store listings. */
  company: string;
  /** Primary domain, without protocol. */
  domain: string;
  /** URL of the product's website. */
  web_url: string;
  /** Path to the brand mark in /public. */
  logoSrc: string;
  support: {
    contact_country_code: string;
    contact_mobile_no: string;
    whatsapp_mobile_no: string;
    contactus_email: string;
    sales_email: string;
    support_email: string;
    privacy_email: string;
  };
}

export const PLATFORM: PlatformConfig = {
  platform_name: 'Inventory++',
  company: 'Mangol Group',
  domain: 'inventoryplusplus.com',
  web_url: 'https://inventoryplusplus.com',
  logoSrc: '/logo.png',
  support: {
    contact_country_code: '+91',
    contact_mobile_no: '7602921397',
    whatsapp_mobile_no: '917602921397',
    contactus_email: 'contactus@inventoryplusplus.com',
    sales_email: 'sales@inventoryplusplus.com',
    support_email: 'support@inventoryplusplus.com',
    privacy_email: 'privacy@inventoryplusplus.com',
  },
};
